<template>
  <section class="c-previous-winner block p-t-b text-center font-default">
    <h2 class="c-previous-winner__title fnt font-deco">
      {{ $t("HOMEPAGE__PREVIOUS_WINNER_TITLE") }}
    </h2>

    <div class="c-previous-winner__photos">
      <img
        v-for="image in winnerImages"
        :key="image.src"
        class="c-previous-winner__photo"
        :src="image.src"
        :alt="$t(image.alt)"
      />
    </div>

    <div class="c-previous-winner__content">
      <p v-html="$t('HOMEPAGE__PREVIOUS_WINNER_INTRO')"></p>
      <h3 class="c-previous-winner__subtitle fnt font-default">
        {{ $t("HOMEPAGE__PREVIOUS_WINNER_QUESTION") }}
      </h3>
      <p v-html="$t('HOMEPAGE__PREVIOUS_WINNER_REGISTER')"></p>
    </div>

    <div v-if="$slots.cta" class="c-previous-winner__cta">
      <slot name="cta"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "PreviousWinnerSection",
  data() {
    return {
      winnerImages: [
        {
          src:
            "https://contest2018.s3.amazonaws.com/winners/2025/magali-2025-grand-prize-winner-portrait.jpg",
          alt: "HOMEPAGE__PREVIOUS_WINNER_ALT_PORTRAIT"
        },
        {
          src:
            "https://contest2018.s3.amazonaws.com/winners/2025/magali-2025-dream-trip-winner.jpg",
          alt: "HOMEPAGE__PREVIOUS_WINNER_ALT_WINNER"
        }
      ]
    }
  }
}
</script>
